import type {
  NitroFetchOptions,
  NitroFetchRequest,
  TypedInternalResponse
} from 'nitropack'
import type { ValidateOptions } from '../types/validate-options'
import { HttpError } from './error'

interface CreateOptionsParams extends ValidateOptions {
  apiUrl: string
  token?: string | null
}

const getErrorMessage = (data: any): string | null => {
  if (!data) {
    return null
  }
  if (typeof data === 'object') {
    if (data.message) {
      return data.message
    }
  }
  if (typeof data === 'string') {
    return data.trim()
  }
  return null
}

const throwDetailedHttpError = (
  response: TypedInternalResponse<any, any>,
  request: NitroFetchRequest
) => {
  const url = typeof request === 'string' ? request : request.url
  const method =
    typeof request === 'object' && 'method' in request
      ? request.method
      : 'unknown'
  let errorMessage = `HTTP Error: ${response.status} - ${response.statusText} for ${method} request to ${url}`

  const dataError = getErrorMessage(response._data)
  if (dataError) {
    errorMessage += `: ${dataError}`
  }

  throw new HttpError(
    errorMessage,
    response.status,
    response.statusText,
    url,
    method,
    response._data
  )
}

export function createOptions(params?: CreateOptionsParams) {
  const { apiUrl, responseSchema } = params ?? {}

  return {
    baseURL: apiUrl,
    // onRequest: () => {},
    onResponse: ({ response, request }) => {
      if (response.status !== 200) {
        throwDetailedHttpError(response, request)
      }

      if (responseSchema) {
        const result = responseSchema.safeParse(response._data)
        if (result.success) {
          return response._data
        }
        const url = typeof request === 'string' ? request : request.url
        console.error('API 資料檢核錯誤')
        console.error({
          data: response._data,
          response,
          request,
          apiUrl: url,
          result
        })
      }

      return response._data
    }
    // onResponseError: () => {}
  } satisfies NitroFetchOptions<string>
}
